export default __webpack_public_path__ + "static/media/logo_Yonsei.74575fe9.png";